import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=5889b941&"
import script from "./NewsCarousel.vue?vue&type=script&lang=js&"
export * from "./NewsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports